import { executePost } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const EditEventApi = async (data, cb) => {
    try {
        const eventData = await executePost("/edit-event", data);
        const editEventventData = eventData.data
            ? eventData.data
            : [];
        return editEventventData;
    } catch (error) {
        console.log("error",error)
        if (error?.response?.data?.message === "Token is invalid!") {
            toast.dismiss();
            toast.clearWaitingQueue();
            toast.error(SessionTimeout, {
                position: "top-center",
                width: "500px",
                autoClose: 6000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            removeUserCredentials();
            if (cb) {
                cb();
            }
        } else {
            return false;
        }
    }
}